module.exports = __webpack_public_path__ + "assets/media/lunch.1847bdfd.mp3";